import * as React from 'react'

function SvgOm(props) {
	return (
		<svg viewBox="0 0 1200 600" width="1em" height="1em" {...props}>
			<path fill="#db161b" d="M0 0h1200v600H0z" />
			<path fill="#fff" d="M300 0h900v200H300z" />
			<path fill="green" d="M300 400h900v200H300z" />
			<g
				id="om_svg__a"
				fillRule="evenodd"
				stroke="#db161b"
				strokeWidth={0.352}
				fill="#fff"
			>
				<rect
					rx={3.215}
					ry={3.015}
					height={21.217}
					width={38.669}
					y={102.64}
					x={65.854}
					strokeWidth={0.378}
				/>
				<rect rx={3.05} ry={2.764} height={19.449} width={36.686} y={103.52} x={66.846} />
				<path
					d="M83.904 108.83l1.853.06.084.84 1.516.77 1.18-.96 1.431.77-1.347.84.337 1.16 1.684-.06v1.55l-1.347-.07-.674.97 1.516 1.1-1.179.9-1.264-.97-1.853.39.084 1.42-2.021.13-.253-1.36-1.684-.71-.927.97-1.432-.71.843-1.1-1.011-.71h-1.432l-.084-2 1.432.13 1.01-1.16-1.179-.9 1.516-1.04 1.095.84 1.853-.25.253-.84z"
					strokeWidth={0.222}
				/>
				<ellipse
					cx={68.944}
					cy={426.78}
					rx={11.049}
					ry={9.944}
					transform="matrix(.18418 0 0 .1752 71.766 38.246)"
					strokeWidth="1pt"
				/>
				<path d="M71.803 104.41l-2.974 2.65M73.786 104.41l-2.974 2.65M75.769 104.41l-2.974 2.65M77.752 104.41l-2.974 2.65M79.735 104.41l-2.974 2.65M81.718 104.41l-2.974 2.65M83.702 104.41l-2.975 2.65M85.685 104.41l-2.975 2.65M87.668 104.41l-2.975 2.65M89.651 104.41l-2.975 2.65M91.634 104.41l-2.975 2.65M93.617 104.41l-2.975 2.65M85.685 104.41l-2.975 2.65M95.6 104.41l-2.975 2.65M97.583 104.41l-2.975 2.65M99.566 104.41l-2.975 2.65M101.55 104.41l-2.976 2.65M98.574 104.41l2.976 2.65M96.591 104.41l2.975 2.65M94.608 104.41l2.975 2.65M92.625 104.41l2.975 2.65M90.642 104.41l2.975 2.65M88.659 104.41l2.975 2.65M86.676 104.41l2.975 2.65M84.693 104.41l2.975 2.65M82.71 104.41l2.975 2.65M80.727 104.41l2.975 2.65M78.744 104.41l2.975 2.65M76.761 104.41l2.974 2.65M84.693 104.41l2.975 2.65M74.778 104.41l2.974 2.65M72.795 104.41l2.974 2.65M70.812 104.41l2.974 2.65M68.829 104.41l2.974 2.65M71.803 119.43l-2.974 2.66M73.786 119.43l-2.974 2.66M75.769 119.43l-2.974 2.66M77.752 119.43l-2.974 2.66M79.735 119.43l-2.974 2.66M81.718 119.43l-2.974 2.66M83.702 119.43l-2.975 2.66M85.685 119.43l-2.975 2.66M87.668 119.43l-2.975 2.66M89.651 119.43l-2.975 2.66M91.634 119.43l-2.975 2.66M93.617 119.43l-2.975 2.66M85.685 119.43l-2.975 2.66M95.6 119.43l-2.975 2.66M97.583 119.43l-2.975 2.66M99.566 119.43l-2.975 2.66M101.55 119.43l-2.976 2.66M98.574 119.43l2.976 2.66M96.591 119.43l2.975 2.66M94.608 119.43l2.975 2.66M92.625 119.43l2.975 2.66M90.642 119.43l2.975 2.66M88.659 119.43l2.975 2.66M86.676 119.43l2.975 2.66M84.693 119.43l2.975 2.66M82.71 119.43l2.975 2.66M80.727 119.43l2.975 2.66M78.744 119.43l2.975 2.66M76.761 119.43l2.974 2.66M84.693 119.43l2.975 2.66M74.778 119.43l2.974 2.66M72.795 119.43l2.974 2.66M70.812 119.43l2.974 2.66M68.829 119.43l2.974 2.66" />
			</g>
			<use xlinkHref="#om_svg__a" x={-300} transform="scale(-1 1)" />
			<g id="om_svg__b" stroke="#db161b">
				<path
					d="M126.51 147.12c-48.114 47.05-68.638 53-59.006 56.79s40.616-20.49 72.856-52.75c32.24-32.25 51.98-60.956 42.35-64.747-9.63-3.792-5.03 10.662-56.2 60.707z"
					fillRule="evenodd"
					strokeWidth={0.565}
					fill="#fff"
				/>
				<path
					d="M86.008 181.31l16.852 4.42c-15.861 15.03-33.708 21.22-38.665 18.57-4.958-2.65 8.923-8.84 21.813-22.99z"
					fillRule="evenodd"
					strokeWidth={0.33}
					fill="#fff"
				/>
				<path
					d="M86.008 183.08l13.881 3.54c-15.453 14.45-30.737 18.56-34.692 16.8-3.977-1.77 8.255-6.74 20.811-20.34z"
					fillRule="evenodd"
					strokeWidth={0.33}
					fill="#fff"
				/>
				<path
					d="M137.79 145.06c-.04.23-.15 1.24-.25 1.64 0 .56-.06.98-.12 1.42-.16.38-.13.73-.62.87-.33.46-.54.58-.98.77-.3.23-.76.46-1.24.65-.49.19-.94.21-1.47.11-.44-.27-.75-.54-1.11-.76-.09-.35-.16-.86-.25-1.2.13.35.23.91.25 1.41-.05.55-.25.79-.49 1.2M133.23 152.37c-.04-.03-.08-.07-.12-.11.29.26.17.14-.5-.21-.47-.22-.98-.34-1.6-.44h-1.72c-.67 0-1.12.09-1.6.22-.35.31-.87.48-1.23.76-.38.23-.54.5-.74.87-.34.3-.56.76-.87.99-.13.5-.42.48-.61.87.58.04 1.05.11 1.35.43.52.24-.43-.23-.61-.43-.41-.11-.51-.22-1.11-.22-.56-.16-.9.13-1.48.22-.33.17-.43.22-.86.22M126.58 157.83c-.25.01-1.4.2-1.85 0-.5-.12-.8-.36-1.11-.77-.15-.29 0 .53 0 .88-.05.64-.27.65-.61 1.09-.36.2-.74.49-1.11.65-.31.24-.69.4-1.11.55-.37.15-.81.31-1.11.54-.41.26-.37.58-.61.98.04.54.14.84.49 1.1.14.36.47.73.74.98.3.5.64.73-.13.87-.42.16-.65.03-1.1 0M118.82 165.46c-.3-.06-1.38-.38-1.85-.54h-1.72c-.67.04-.8.22-1.36.43-.36.33-.61.56-1.11.77-.26.3-.78.81-.98 1.2-.15.37-.25.87-.25 1.42.01.63.2.74.25 1.31.14.46.36.89.74 1.3.05.14.09.18.24.22M112.95 173c-.05 0-.17.28-.35.52-.39.4-.44.43-1.05.43-.54-.02-.49-.21-.87-.35-.18-.27-.41-.49-.61-.86-.14-.22-.27-.57-.44-.77-.16-.26-.36-.45-.53-.69-.16-.07-.22-.14-.43-.17.5.08.54.25.87.51.15.25.31.5.44.78.05.37.17.66.17 1.12 0 .47 0 .81-.17 1.2-.21.22-.36.44-.61.61-.21.19-.46.45-.62.68-.27.17-.47.31-.78.52-.27.15-.55.31-.96.35-.52-.04-.67-.18-1.05-.35-.33-.24-.59-.39-.88-.6-.23-.16-.46-.47-.61-.69-.47-.12-.77-.07-1.05.17-.24.16-.45.37-.61.6-.15.07-.38.28-.53.35M103.32 176.56c.14.06.64.41.87.54.14.45.36.7.43 1.18.12.47.11.98.11 1.51-.12.55-.35.95-.54 1.39-.35.24-.52.4-.98.65-.43.06-.86.11-1.41.11-.34.11-.98.16-1.31 0-.48-.07-.843-.26-1.194-.43-.402-.23-.649-.44-1.088-.65-.213-.31-.544-.59-.869-.97-.271-.36-.47-.56-.653-.96.161.46.405.86.544 1.29.247.45.391.62.435 1.18.151.45.109.99.109 1.5-.048.35-.073 1.01-.218 1.29v.33M87.242 186.23v.16c0-.42-.011-.21.175.62.33.37 1.104.47 1.749.31.566-.41.548-.73 1.574-.93.991.06 1.369.32 1.924.62.658.29.962.44 1.399 1.09.217.53.338.89-.35 1.09-.547.35-1.197.54-1.924.63-.808 0-1.39-.09-1.749.31-.555.51-.524.82-.524 1.71-.187.28-.224 1.1-.35 1.41-.486.2-.771.31-1.574.31-.189-.48-.398-1.35-.525-1.87-.137-.56-.179-1.34-.525-1.72a4.51 4.51 0 00-1.224-1.09c-.214-.27-.622-.49-1.049-.62.686.31.784.65.874 1.4-.603.27-.764.46-1.749.47-.968-.07-1.202-.29-1.574-.78-.067.78-.348 1.04-.524 1.72-.36.47-.513.95-.875 1.55.154.76.486.79.525 1.72.227.61.202 1.19.699 1.56.222.24.388.29.875.31-1.013 0-1.603-.1-2.274-.47-.519-.28-.911-.64-1.399-.93-.619-.4-1.384-.77-2.099-.94-.808 0-1.39-.08-1.749.31-.495.32-.828.86-1.049 1.56-.162.81-.224 1.35.175 1.87.296.61.363.84 0 1.56-.407.51-1.012.57-1.924.78a6.678 6.678 0 01-1.749-.31"
					strokeWidth={0.33}
					fill="none"
				/>
				<path
					d="M181.41 104.66c21.35-36.858 35.52-68.222 31.62-70.014-3.89-1.791-24.37 26.665-45.72 63.518l14.1 6.496z"
					fillRule="evenodd"
					strokeWidth={0.447}
					fill="#fff"
				/>
				<path
					d="M180 104.01c20.59-35.557 34.78-65.574 31.67-67.007s-22.35 26.258-42.95 61.81"
					fillRule="evenodd"
					strokeWidth={0.393}
					fill="#fff"
				/>
				<path
					d="M176.46 85.461c-2.51 4.157-5.16 8.908-7.74 13.352L180 104.01c2.57-4.448 5.38-9.13 7.73-13.356l-11.27-5.193z"
					fillRule="evenodd"
					strokeWidth={0.446}
					fill="#fff"
				/>
				<path
					d="M177.41 86.895c-2.5 4.157-4.25 7.338-6.82 11.782l8.45 3.893c2.58-4.442 4.48-7.554 6.83-11.78l-8.46-3.895z"
					fillRule="evenodd"
					strokeWidth={0.446}
					fill="#fff"
				/>
				<path
					transform="matrix(-.90832 -.41827 -.50125 .8653 0 0)"
					strokeWidth={0.447}
					fill="#fff"
					d="M-205.69 6.559h6.207v9.985h-6.207z"
				/>
				<path
					d="M183.55 91.712l-10.64 6.043M178.54 100.35l-.63-11.235M209.03 47.727l-5.64-2.597"
					fillRule="evenodd"
					strokeWidth={0.446}
					fill="#fff"
				/>
				<circle
					transform="matrix(-.449 .1132 .10134 .39387 444.347 -55.798)"
					cy={92.126}
					cx={545.67}
					strokeWidth="1pt"
					fill="#db161b"
					r={3.543}
				/>
			</g>
			<use xlinkHref="#om_svg__b" x={-300} transform="scale(-1 1)" />
			<path
				d="M135.26 84.958c0 30.942.18 42.602-2.1 44.202-2.16 1.71-62.348 0-62.348 8.84s49.578 17.68 64.448 17.68c19.83 0 29.75-8.84 29.75-26.52V84.958h-29.75z"
				fillRule="evenodd"
				stroke="#db161b"
				strokeWidth={0.407}
				fill="#fff"
			/>
			<path
				d="M135.26 93.798v4.42a100.628 100.628 0 0029.75 0v-4.42a100.628 100.628 0 01-29.75 0zM135.26 84.958v4.42a100.695 100.695 0 0029.75 0v-4.42a100.695 100.695 0 01-29.75 0z"
				fillRule="evenodd"
				stroke="#db161b"
				strokeWidth={0.352}
				fill="#fff"
			/>
			<path
				d="M135.26 89.378v4.42a100.628 100.628 0 0029.75 0v-4.42a100.695 100.695 0 01-29.75 0zM135.26 98.218v4.422c9.92 1.47 19.83 1.47 29.75 0v-4.422a100.628 100.628 0 01-29.75 0z"
				fillRule="evenodd"
				stroke="#db161b"
				strokeWidth={0.352}
				fill="#fff"
			/>
			<ellipse
				rx={8.858}
				ry={26.575}
				stroke="#db161b"
				transform="matrix(.15263 0 0 .03588 97.403 84.326)"
				cy={210.83}
				cx={256.89}
				strokeWidth={4.463}
				fill="#fff"
			/>
			<ellipse
				rx={8.858}
				ry={26.575}
				stroke="#db161b"
				transform="matrix(.15263 0 0 .03588 97.403 83.53)"
				cy={246.26}
				cx={292.32}
				strokeWidth={4.463}
				fill="#fff"
			/>
			<ellipse
				rx={8.858}
				ry={26.575}
				stroke="#db161b"
				transform="matrix(.15263 0 0 .03588 97.403 83.372)"
				cy={263.98}
				cx={327.76}
				strokeWidth={4.463}
				fill="#fff"
			/>
			<ellipse
				rx={8.858}
				ry={26.575}
				stroke="#db161b"
				transform="matrix(.15263 0 0 .03588 97.403 83.372)"
				cy={263.98}
				cx={363.19}
				strokeWidth={4.463}
				fill="#fff"
			/>
			<ellipse
				rx={8.858}
				ry={26.575}
				stroke="#db161b"
				transform="matrix(.15263 0 0 .03588 97.403 83.53)"
				cy={246.26}
				cx={398.62}
				strokeWidth={4.463}
				fill="#fff"
			/>
			<ellipse
				rx={8.858}
				ry={26.575}
				stroke="#db161b"
				transform="matrix(.15263 0 0 .03588 97.403 84.326)"
				cy={210.83}
				cx={434.06}
				strokeWidth={4.463}
				fill="#fff"
			/>
			<g fillRule="evenodd" stroke="#db161b" strokeWidth={0.352} fill="#fff">
				<path d="M135.26 107.06l29.75 23.87M138.23 107.06l26.78 21.21M142.2 107.94l22.81 17.68M145.18 107.94l19.83 15.03M148.15 107.94l16.86 12.38M151.12 107.94l13.89 9.73M154.1 107.94l10.91 7.07M157.07 107.94l7.94 5.31M160.05 107.94l4.96 3.54M163.02 107.94l1.99 1.77M135.26 109.71l29.75 23.87M165.01 107.06l-32.72 26.52M162.03 107.06l-28.75 22.98M158.07 107.94l-22.81 17.68M155.09 107.94l-19.83 15.03M152.12 107.94l-16.86 12.38M149.14 107.94l-13.88 9.73M146.17 107.94l-10.91 7.07M143.19 107.94l-7.93 5.31M140.22 107.94l-4.96 3.54M137.24 107.94l-1.98 1.77M165.01 109.71l-32.72 26.52M165.01 112.36l-32.72 26.52M165.01 115.01l-32.72 26.53M165.01 117.67l-32.72 26.52M165.01 120.32l-32.72 26.52M165.01 122.97l-32.72 26.52M165.01 125.62l-32.72 26.52M165.01 128.28l-32.72 26.52M165.01 130.93l-30.74 24.75M165.01 133.58l-27.77 22.1M164.01 137.12L142.2 154.8M163.02 140.65l-17.84 14.15M161.04 145.07l-8.92 7.07M135.26 112.36l28.75 22.99M135.26 115.01L164.01 138M135.26 117.67l27.76 22.1M135.26 120.32l27.76 22.1M135.26 122.97l26.77 21.22M134.27 124.74l26.77 21.22M134.27 127.39l24.79 19.45M133.28 129.16l24.79 19.45M132.29 130.93l23.79 18.56M132.29 133.58l22.8 17.68M132.29 136.23l19.83 15.91" />
			</g>
			<path
				d="M135.26 102.64v4.42c9.92 1.47 19.83 1.47 29.75 0v-4.42c-9.92 1.47-19.83 1.47-29.75 0zM132.29 138.88l17.84 14.15M132.29 141.54l15.86 12.37M132.29 144.19l13.88 10.61M132.29 146.84l9.91 7.96M132.29 149.49l7.93 6.19M132.29 152.14l4.95 3.54"
				fillRule="evenodd"
				stroke="#db161b"
				strokeWidth={0.352}
				fill="#fff"
			/>
			<ellipse
				rx={8.858}
				ry={26.575}
				stroke="#db161b"
				transform="matrix(.15263 0 0 .03588 97.403 97.586)"
				cy={210.83}
				cx={256.89}
				strokeWidth={4.463}
				fill="#fff"
			/>
			<ellipse
				rx={8.858}
				ry={26.575}
				stroke="#db161b"
				transform="matrix(.15263 0 0 .03588 97.403 96.791)"
				cy={246.26}
				cx={292.32}
				strokeWidth={4.463}
				fill="#fff"
			/>
			<ellipse
				rx={8.858}
				ry={26.575}
				stroke="#db161b"
				transform="matrix(.15263 0 0 .03588 97.403 96.632)"
				cy={263.98}
				cx={327.76}
				strokeWidth={4.463}
				fill="#fff"
			/>
			<ellipse
				rx={8.858}
				ry={26.575}
				stroke="#db161b"
				transform="matrix(.15263 0 0 .03588 97.403 96.632)"
				cy={263.98}
				cx={363.19}
				strokeWidth={4.463}
				fill="#fff"
			/>
			<ellipse
				rx={8.858}
				ry={26.575}
				stroke="#db161b"
				transform="matrix(.15263 0 0 .03588 97.403 96.791)"
				cy={246.26}
				cx={398.62}
				strokeWidth={4.463}
				fill="#fff"
			/>
			<ellipse
				rx={8.858}
				ry={26.575}
				stroke="#db161b"
				transform="matrix(.15263 0 0 .03588 97.403 97.586)"
				cy={210.83}
				cx={434.06}
				strokeWidth={4.463}
				fill="#fff"
			/>
			<g fillRule="evenodd" stroke="#db161b" strokeWidth={0.352} fill="#fff">
				<path d="M92.625 148.61l35.695-18.57M90.642 147.72l33.708-17.68M89.651 145.96l30.739-15.92M88.659 144.19l26.771-14.15M86.676 142.42l24.784-12.38M87.668 139.77l16.852-8.84M86.676 138l12.89-7.07M86.676 135.35l8.924-4.42M95.6 149.49l33.71-17.68M98.574 150.38l31.726-16.8M101.55 151.26l29.74-15.91M104.52 152.14l24.79-13.26M108.49 152.14l21.81-11.49M111.46 153.03l18.84-9.73M114.44 153.91l14.87-7.95M118.4 153.91l11.9-6.19M122.37 154.8l7.93-4.42M126.34 154.8l4.95-2.66" />
			</g>
			<path
				d="M133.28 129.16h-4.96a71.66 71.66 0 000 26.52h4.96a71.236 71.236 0 010-26.52zM74.778 141.54l11.898-8.84M74.778 135.35l11.898 10.61"
				fillRule="evenodd"
				stroke="#db161b"
				strokeWidth={0.352}
				fill="#fff"
			/>
			<path
				d="M92.625 130.93l-5.949.88c-1.322 5.6-1.322 10.31 0 15.91l5.949 1.77c-1.322-5.6-1.322-12.96 0-18.56z"
				fillRule="evenodd"
				stroke="#db161b"
				strokeWidth={0.251}
				fill="#fff"
			/>
			<path
				d="M164.97 86.726v-4.457c-4.45.037-7.43-2.615-7.43-5.305l-14.85.037c0 2.653-2.97 5.305-7.43 5.305v4.42h29.71z"
				fillRule="evenodd"
				stroke="#db161b"
				strokeWidth={0.431}
				fill="#fff"
			/>
			<path
				stroke="#db161b"
				strokeWidth={0.364}
				fill="#fff"
				d="M143.75 71.697h12.734v5.304H143.75zM144.81 66.393h10.612v5.304H144.81zM144.81 61.089h10.612v5.304H144.81z"
			/>
			<path
				stroke="#db161b"
				strokeWidth={0.364}
				fill="#fff"
				d="M145.87 54.017h8.489v7.072h-8.489z"
			/>
			<path
				stroke="#db161b"
				strokeWidth={0.38}
				fill="#fff"
				d="M145.51 47.829h9.221v6.188h-9.221z"
			/>
			<ellipse
				rx={42.52}
				ry={33.661}
				stroke="#db161b"
				transform="matrix(.28916 0 0 .2495 81.983 1.86)"
				cy={161.22}
				cx={237.4}
				strokeWidth="1pt"
				fill="#fff"
			/>
			<path
				d="M156.78 41.64c0 2.319 3.07 6.189 3.07 6.189-2.23 1.52-5.83 2.652-9.22 2.652s-7.62-.631-9.22-2.652c0 0 3.07-3.87 3.07-6.189 0-2.318-3.07-5.304-3.07-5.304 2.22-1.52 5.83-2.652 9.22-2.652s6.99 1.132 9.22 2.652c0 0-3.07 2.986-3.07 5.304z"
				fillRule="evenodd"
				stroke="#db161b"
				strokeWidth={0.358}
				fill="#fff"
			/>
			<path
				d="M154.73 41.64c0 2.319 3.07 7.073 3.07 7.073-2.22 1.52-3.78 1.768-7.17 1.768s-5.57.253-7.17-1.768c0 0 3.07-4.754 3.07-7.073 0-2.318-3.07-6.188-3.07-6.188 2.22-1.52 3.78-1.768 7.17-1.768s4.95.248 7.17 1.768c0 0-3.07 3.87-3.07 6.188z"
				fillRule="evenodd"
				stroke="#db161b"
				strokeWidth={0.358}
				fill="#fff"
			/>
			<circle
				stroke="#db161b"
				transform="matrix(.28916 0 0 .2495 81.983 .975)"
				cy={166.54}
				cx={194.88}
				strokeWidth="1pt"
				fill="#fff"
				r={10.63}
			/>
			<circle
				stroke="#db161b"
				transform="matrix(.28916 0 0 .2495 106.572 .975)"
				cy={166.54}
				cx={194.88}
				strokeWidth="1pt"
				fill="#fff"
				r={10.63}
			/>
			<circle
				stroke="#db161b"
				transform="matrix(.28916 0 0 .2495 94.278 .975)"
				cy={166.54}
				cx={194.88}
				strokeWidth="1pt"
				fill="#fff"
				r={10.63}
			/>
			<circle
				stroke="#db161b"
				transform="matrix(.28916 0 0 .2495 94.278 -7.865)"
				cy={166.54}
				cx={194.88}
				strokeWidth="1pt"
				fill="#fff"
				r={10.63}
			/>
			<circle
				stroke="#db161b"
				transform="matrix(.29948 0 0 .2495 83.264 42.524)"
				cy={166.54}
				cx={194.88}
				strokeWidth="1pt"
				fill="#fff"
				r={10.63}
			/>
			<circle
				stroke="#db161b"
				transform="matrix(.29948 0 0 .2495 100.242 42.524)"
				cy={166.54}
				cx={194.88}
				strokeWidth="1pt"
				fill="#fff"
				r={10.63}
			/>
			<path
				d="M142.69 77.001h14.85l-7.42 7.957-7.43-7.957z"
				fillRule="evenodd"
				stroke="#db161b"
				strokeWidth={0.364}
				fill="#fff"
			/>
			<circle
				stroke="#db161b"
				transform="matrix(.39931 0 0 .33266 72.298 27.79)"
				cy={166.54}
				cx={194.88}
				strokeWidth="1pt"
				fill="#fff"
				r={10.63}
			/>
			<rect
				rx={1.238}
				ry={0.938}
				height={5.304}
				width={22.805}
				stroke="#db161b"
				y={109.72}
				x={133.77}
				strokeWidth={0.33}
				fill="#fff"
			/>
			<path
				d="M163.52 105.3c-2.75 0-4.96 2.06-4.96 4.62v4.02c0 2.56 2.21 4.62 4.96 4.62s4.96-2.06 4.96-4.62v-4.02c0-2.56-2.21-4.62-4.96-4.62zm0 1.77c-1.65 0-2.98 1.65-2.98 3.7v2.33c0 2.05 1.33 3.69 2.98 3.69s2.97-1.64 2.97-3.69v-2.33c0-2.05-1.32-3.7-2.97-3.7zM137.74 106.19c-1.65 0-2.97 1.64-2.97 3.69v4.1c0 2.05 1.32 3.7 2.97 3.7s2.97-1.65 2.97-3.7v-4.1c0-2.05-1.32-3.69-2.97-3.69zm0-1.77c-2.75 0-4.96 2.06-4.96 4.62v5.79c0 2.56 2.21 4.62 4.96 4.62s4.96-2.06 4.96-4.62v-5.79c0-2.56-2.21-4.62-4.96-4.62z"
				fillRule="evenodd"
				stroke="#db161b"
				strokeWidth={0.33}
				fill="#fff"
			/>
			<path
				d="M129.81 107.95c-1.65 0-2.98 1.65-2.98 3.7v.96c0 2.05 1.33 3.7 2.98 3.7s2.97-1.65 2.97-3.7v-.96c0-2.05-1.32-3.7-2.97-3.7zm0-1.76c-2.75 0-4.96 2.06-4.96 4.62v2.65c0 2.56 2.21 4.62 4.96 4.62 2.74 0 4.96-2.06 4.96-4.62v-2.65c0-2.56-2.22-4.62-4.96-4.62z"
				fillRule="evenodd"
				stroke="#db161b"
				strokeWidth={0.33}
				fill="#fff"
			/>
			<path
				d="M117.91 105.51c-2.97 0-5.35 1.84-5.35 4.13v4.58c0 2.29 2.38 4.13 5.35 4.13s5.35-1.84 5.35-4.13v-4.58c0-2.29-2.38-4.13-5.35-4.13zm0-1.98c-4.94 0-8.92 2.31-8.92 5.17v6.47c0 2.86 3.98 5.16 8.92 5.16s8.92-2.3 8.92-5.16v-6.47c0-2.86-3.98-5.17-8.92-5.17zM182.36 106.39c-2.97 0-5.36 1.85-5.36 4.14v4.58c0 2.29 2.39 4.13 5.36 4.13 2.96 0 5.35-1.84 5.35-4.13v-4.58c0-2.29-2.39-4.14-5.35-4.14zm0-1.97c-4.95 0-8.93 2.3-8.93 5.16v6.47c0 2.86 3.98 5.16 8.93 5.16 4.94 0 8.92-2.3 8.92-5.16v-6.47c0-2.86-3.98-5.16-8.92-5.16z"
				fillRule="evenodd"
				stroke="#db161b"
				strokeWidth={0.33}
				fill="#fff"
			/>
			<rect
				rx={0.646}
				ry={0.938}
				height={5.304}
				width={11.898}
				stroke="#db161b"
				y={109.72}
				x={165.5}
				strokeWidth={0.33}
				fill="#fff"
			/>
			<rect
				rx={0.377}
				ry={1.251}
				height={7.072}
				width={6.941}
				stroke="#db161b"
				y={108.84}
				x={154.6}
				strokeWidth={0.33}
				fill="#fff"
			/>
			<rect
				rx={0.377}
				ry={1.251}
				height={7.072}
				width={6.941}
				stroke="#db161b"
				y={108.84}
				x={121.88}
				strokeWidth={0.33}
				fill="#fff"
			/>
			<rect
				rx={0.753}
				ry={1.563}
				height={8.84}
				width={13.881}
				stroke="#db161b"
				y={107.95}
				x={100.06}
				strokeWidth={0.33}
				fill="#fff"
			/>
			<rect
				rx={0.7}
				ry={1.563}
				height={8.84}
				width={12.89}
				stroke="#db161b"
				y={108.84}
				x={186.32}
				strokeWidth={0.33}
				fill="#fff"
			/>
		</svg>
	)
}

export default SvgOm
